import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-container background-gray q-py-lg" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "section-container background-gray",
  style: {"padding-bottom":"32px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-mb-lg" }, null, -1)
const _hoisted_7 = { class: "col-12 q-mb-md" }
const _hoisted_8 = { class: "offer__img-wrap" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col q-ma-md" }
const _hoisted_11 = {
  class: "q-my-none text-weight-bolder",
  style: {"font-size":"16px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_13 = { class: "row items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "additional-text" }, "ID:", -1)
const _hoisted_15 = { class: "q-mx-sm" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_17 = { class: "row items-center" }
const _hoisted_18 = { class: "additional-text" }
const _hoisted_19 = { class: "row q-col-gutter-md q-mb-lg background-gray" }
const _hoisted_20 = { class: "col-12 col-md-6" }
const _hoisted_21 = { class: "bg-white q-pt-lg offer-col-left" }
const _hoisted_22 = { class: "title-wrap" }
const _hoisted_23 = { class: "q-my-none page-subtitle" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)
const _hoisted_25 = { class: "col-12 col-md-6" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrap bg-white q-py-lg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "q-my-none page-subtitle" }, "Terms"),
  /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" })
], -1)
const _hoisted_28 = { class: "column q-mb-xl bg-white q-pt-lg" }
const _hoisted_29 = { class: "row items-center justify-between title-wrap" }
const _hoisted_30 = { class: "page-subtitle" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = {
  key: 1,
  class: "q-ml-lg notify-error q-pa-md bordered"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-md" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_center = _resolveComponent("center")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_OfferRates = _resolveComponent("OfferRates")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_OfferLandings = _resolveComponent("OfferLandings")!
  const _component_CampaignEditDialog = _resolveComponent("CampaignEditDialog")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "Offers > " + _toDisplayString(_ctx.offer.name), 1),
          (!_ctx.hasAccess(_ctx.offer.offersAccess && _ctx.offer.offersAccess?.status))
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                "no-caps": "",
                color: "primary",
                class: "q-btn__main-size",
                unelevated: "",
                disable: !!_ctx.offer.offersAccess,
                label: _ctx.offer.offersAccess ? _ctx.$t('had_access') : _ctx.$t('access'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getAccess()))
              }, null, 8, ["disable", "label"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_center, {
            key: 0,
            class: "q-mt-lg"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_spinner, {
                color: "primary",
                size: "3em",
                thickness: 2
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_q_card, {
                  class: "card row q-pa-none overflow-hidden offer-top bg-white",
                  flat: "",
                  bordered: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: `${_ctx.storageUrl + '/' + _ctx.offer.image}`,
                        alt: "",
                        class: "offer__img"
                      }, null, 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.offer.name), 1),
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.offer.id), 1)
                      ]),
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('traffic_type')) + ":", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offer.trafficSources, (trafficSource, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "row q-mx-sm",
                            key: index
                          }, _toDisplayString(trafficSource.name), 1))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('conditions')), 1),
                    _hoisted_24
                  ]),
                  _createVNode(_component_OfferRates, { rates: _ctx.ratesData }, null, 8, ["rates"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_q_card, { flat: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, {
                        innerHTML: _ctx.offer.description
                      }, null, 8, ["innerHTML"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('landings')), 1),
                _createElementVNode("div", _hoisted_31, [
                  (_ctx.hasAccess(_ctx.offer.offersAccess && _ctx.offer.offersAccess?.status))
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        "no-caps": "",
                        class: "q-py-sm q-px-lg q-btn__main-size text-weight-bold",
                        "icon-right": "add",
                        label: _ctx.$t('create_campaign'),
                        color: "primary",
                        unelevated: "",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCampaignEditDialog = !_ctx.showCampaignEditDialog))
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (
                _ctx.$q.screen.width >= 600 &&
                  _ctx.offer.offersAccess?.status === _ctx.statuses.Closed &&
                  _ctx.offer.offersAccess.closedBy
              )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('offer_closed')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_33,
              _createVNode(_component_OfferLandings, {
                promos: _ctx.promos,
                offer: _ctx.offer
              }, null, 8, ["promos", "offer"])
            ])
          ])),
      (_ctx.showCampaignEditDialog)
        ? (_openBlock(), _createBlock(_component_CampaignEditDialog, {
            key: 2,
            open: _ctx.showCampaignEditDialog,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (this.showCampaignEditDialog = false)),
            onRefresh: _ctx.onRequest,
            offerId: _ctx.offer.id
          }, null, 8, ["open", "onRefresh", "offerId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}